export type Order = "asc" | "desc";

/** a non lodash way to get nested object properties with fallback value */
export const resolvePath = (object: Record<string, any>, path: string, defaultValue?: any) =>
  path.split(".").reduce((o, p) => (o ? o[p] : defaultValue), object);
